export const numberFormats = {
    'en-NG': {
        currency: {
          style: 'currency', currency: 'NGN'
        }
    },
    'fr-NG': {
      currency: {
        style: 'currency', currency: 'NGN'
      }
  },
    'fr-GH': {
      currency: {
        style: 'currency', currency: 'GHS'
      }
    },
    'fr-CI': {
      currency: {
        style: 'currency', currency: 'XOF'
      }
    },
    'en-US': {
      currency: {
        style: 'currency', currency: 'USD'
      }
    },
    'fr-FR': {
        currency: {
          style: 'currency', currency: 'EUR'
        }
      },

      'en-FR': {
        currency: {
          style: 'currency', currency: 'EUR'
        }
      },
    'ja-JP': {
      currency: {
        style: 'currency', currency: 'JPY', currencyDisplay: 'symbol'
      },
    },
    'en-KE': {
      currency: {
        style: 'currency', currency: 'KES'
      }
    }
}